const Getters = {
  salesRegisterConfirmDialog: (state) => {
    return state.salesRegisterConfirmDialog
  },
  getSaleListFromState: (state) => {
    return state.saleList
  },
  getMetaAndSummaryFromState: (state) => {
    return [state.meta, state.summary]
  },
  getSaleListAllResponseFromState: (state) => {
    return state
  },
  getSalePaymentListFromState: (state) => {
    return state.salePaymentList
  },
  getRackNumberByPaymentFromState: (state) => {
    return state.rackNumberByProduct
  },
  getSaleDetailFromState: (state) => {
    return state.saleDetail
  },
  getBulkOperationCompletedFromState: (state) => {
    return state.bulkOperationCompleted
  }
}

export default Getters
